import { useEffect } from 'react';

/**
 * @deprecated Runtime head mutation has been removed per SEO best practices.
 * Page-level SEO is now handled via static index.html tags and platform-managed settings.
 * This no-op export remains for backwards compatibility with existing page imports.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function useSEO(_props: {
  title?: string;
  description?: string;
  keywords?: string;
  path?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  noindex?: boolean;
  canonical?: string;
  robots?: string;
  dateModified?: string;
}) {
  // No-op: head mutations removed. SEO managed statically via index.html.
}

interface SchemaProps {
  id: string;
  schema: Record<string, unknown>;
}

export function useSchemaLD({ id, schema }: SchemaProps) {
  useEffect(() => {
    let script = document.getElementById(id) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = id;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);

    return () => {
      script?.remove();
    };
  }, [id, schema]);
}